// extracted by mini-css-extract-plugin
export default {"landingContainer":"page_landingContainer__ZfPJj","blurOverlay":"page_blurOverlay__W+pSF"};